import angular from 'angular';
import ManageSmsNotificationViewComponent
  from './components/manage-sms-notification-view/manage-sms-notification-view-component';
import ManageSmsNotificationEditComponent
  from './components/manage-sms-notification-edit/manage-sms-notification-edit-component';

export default angular
  .module('manage-sms-notifications', [])
  .component('manageSmsNotificationEdit', new ManageSmsNotificationEditComponent())
  .component('manageSmsNotificationView', new ManageSmsNotificationViewComponent());



// WEBPACK FOOTER //
// ./src/modules/sms/components/manage-sms-notification/manage-sms-notification-component.js